(function() { module.exports = window["ReactDOM"]; }());